import { hasPermission, PRIVILEGED_ROLES } from '@blimo/shared';

/** @param {{ roles?: string[] } | null | undefined} user */
export function isPrivileged(user) {
  return Boolean(user?.roles?.some((r) => PRIVILEGED_ROLES.includes(r)));
}

/**
 * Roles the current user may grant (UserPolicy: super-admin/admin only with roles.manage).
 * @param {Array<{ name: string }>|undefined} roles  GET /admin/roles
 * @param {any} me
 */
export function assignableRoles(roles, me) {
  const canManageRoles = hasPermission(me, 'roles.manage');
  return (roles ?? []).filter((r) => canManageRoles || !PRIVILEGED_ROLES.includes(r.name));
}

/** UX mirror of UserPolicy::update. @param {any} me @param {any} user */
export function canManageUser(me, user) {
  if (!hasPermission(me, 'users.manage')) return false;
  return !isPrivileged(user) || hasPermission(me, 'roles.manage');
}

/** UX mirror of UserPolicy::impersonateUser. @param {any} me @param {any} user */
export function canImpersonate(me, user) {
  return hasPermission(me, 'impersonate') && String(me?.id) !== String(user?.id) && !isPrivileged(user) && user?.status === 'active' && !me?.impersonating;
}

/** ISO datetime → yyyy-MM-dd for <input type="date">. @param {string|null|undefined} iso */
export function toDateInput(iso) {
  return typeof iso === 'string' && iso.length >= 10 ? iso.slice(0, 10) : '';
}
